import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WalletCardShimmerComponent } from './wallet-card-shimmer.component';

@NgModule({
  declarations: [
    WalletCardShimmerComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    WalletCardShimmerComponent
  ]
})
export class WalletCardShimmerModule { }
